// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d521569","239":"d9d04dfb","373":"4495aac5","453":"0098adef","553":"b22cdb4d"}[chunkId] + ".chunk.js";
};